import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from './loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
    constructor(private loadService: LoaderService) {}

    color = 'warn';
    mode = 'indeterminate';
    value = 50;
    diameter = 40;
    isLoading: Subject<boolean> = this.loadService.isLoading;

    @Input() initialize = true;

    ngOnInit() {
        Promise.resolve(null).then(() => this.loadService.show());
        // console.log('comp', this.isLoading);
        // this.isLoading.subscribe((s) => console.log(s));
        // console.log(this.loadService.test);
    }
}
